/**
 * Числовые радиусы для JS-компонента Squircle — зеркало `vars/_radius.scss`.
 * CSS-переменная сюда не подставляется: библиотеке нужен именно number.
 */
export const RADIUS = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
} as const;
